import React from 'react';
import { motion } from 'framer-motion';

// Subtle fade-up entrance used across sections.
export const Reveal = ({ children, delay = 0, y = 26, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-70px' }}
    transition={{ duration: 0.55, delay, ease: 'easeOut' }}
  >
    {children}
  </motion.div>
);
